import IncomingCallIcon from "../assets/callIncomingIcon.svg";
import OutgoingCallIcon from "../assets/callOutgoingIcon.svg";
import MissedCallIcon from "../assets/missedCallIcon.svg";
import OutgoingMissedIcon from "../assets/outboundMissedIcon.svg";
import EyeIcon from "../assets/eye-icon.svg";
import { Call } from "../amazon-connect/models/call";

/**
 *Parses timeString into date format
 * @param {*} date
 */
export function getLocaleTimeString(date: any) {
  if (!date) {
    date = new Date();
  }
  date = new Date(date);
  var now = new Date();
  let dateDiff = now.getTime() - date.getTime();
  let dateString = "";

  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  if (month.toString().length === 1) {
    month = "0" + month;
  }
  if (day.toString().length === 1) {
    day = "0" + day;
  }
  if (hour.toString().length === 1) {
    hour = "0" + hour;
  }
  if (minute.toString().length === 1) {
    minute = "0" + minute;
  }
  if (second.toString().length === 1) {
    second = "0" + second;
  }
  if (dateDiff > 24 * 60 * 60 * 1000) {
    dateString =
      year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second;
  } else {
    if (dateDiff >= 1000 * 60 * 60) {
      let hoursAgo = Math.floor(dateDiff / (1000 * 60 * 60));
      dateString = hoursAgo === 1 ? " AN HOUR AGO" : hoursAgo + " HOURS AGO";
    } else if (dateDiff >= 1000 * 60) {
      let minutesAgo = Math.floor(dateDiff / (1000 * 60));
      dateString =
        minutesAgo === 1 ? " A MINUTE AGO" : minutesAgo + " MINUTES AGO";
    } else if (dateDiff >= 1000) {
      let secondsAgo = Math.floor(dateDiff / 1000);
      dateString =
        secondsAgo === 1 ? " A SECOND AGO" : secondsAgo + " SECONDS AGO";
    } else {
      dateString = "NOW";
    }
  }
  return dateString;
}

/**
 * Parses seconds duration  to return time string
 * @param {*seconds} seconds
 * @returns Time String like: 00:00:00
 */
export function getLocaleTimeDuration(seconds: number) {
  let dStr = "";
  let h = Math.floor(seconds / (60 * 60));
  let s = Math.floor((seconds % (60 * 60)) % 60);
  let m = Math.floor((seconds % (60 * 60)) / 60);
  if (h > 0) {
    dStr += h + " Hr" + (h > 1 ? "s " : " ");
  }
  if (m > 0) {
    dStr += m + " Min" + (m > 1 ? "s " : " ");
  }
  if (s > 0) {
    dStr += s + " Sec" + (s > 1 ? "s " : " ");
  }
  return dStr;
}

/**
 *
 * @param {*} secs
 */
export function getLocaleTimeDelimited(secs: number) {
  let mins = 0,
    hrs = 0;
  secs = Math.floor(secs);
  if (secs >= 60) {
    mins = Math.floor(secs / 60);
    secs = secs % 60;
  }

  if (mins >= 60) {
    hrs = Math.floor(mins / 60);
    mins = mins % 60;
  }
  return (
    hrs.toString().padStart(2, 0 as unknown as string) +
    ":" +
    mins.toString().padStart(2, 0 as unknown as string) +
    ":" +
    secs.toString().padStart(2, 0 as unknown as string)
  );
}

/**
 * @param function
 */

export const debounce = (func: any, delay: number) => {
  let debounceTimer: any;
  return function (this: any) {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const makeSearcher = function (terms: string[]) {
  var regex = new RegExp(terms.join("|"));
  return function (str: string) {
    return regex.test(str);
  };
};

export const canMakeCall = (medialList: string) => {
  if (medialList && medialList.length === 0) {
    return false;
  }
  return true;
};

export const createPromiseForFetch = (fetchUrl: string, timeout: number) => {
  return new Promise((resolve, reject) => {
    try {
      const controller = new AbortController();
      const id = setTimeout(() => controller.abort(), timeout);
      fetch(fetchUrl, {
        signal: controller.signal,
      })
        .then(() => {
          clearTimeout(id);
          resolve("ok");
        })
        .catch(() => {
          clearTimeout(id);
          // reject('error');
          resolve("ok");
        });
    } catch (error) {
      reject("error");
    }
  });
};

// Function to merge two arrays with unique elements based on a key
export function mergeUnique(arr1: any[], arr2: any[], key: string) {
  const unique = new Map(arr1.map((item) => [item[key], item]));

  arr2.forEach((item) => {
    if (!unique.has(item[key])) {
      unique.set(item[key], item);
    }
  });

  return Array.from(unique.values());
}

// ccp function
export function formatAttributes(attributes: any) {
  let attributesObj: any = {};
  for (const key in attributes) {
    const val = attributes[key];
    if (val.name) attributesObj[val.name] = val.value;
  }
  return attributesObj;
}

export function formatCaseAttributes(attributes: any): {
  [key: string]: string;
} {
  let attributesObj: any = {};
  for (const key in attributes) {
    attributesObj[key] = attributes[key].value;
  }
  return attributesObj;
}
export const checkMicrophonePermission = () => {
  window.navigator.permissions
    .query({ name: "microphone" as PermissionName })
    .then((result) => {
      if (result.state === "granted") {
        //this.window.close();
        console.log("AIC ccp window: Microphone permission granted");
      } else {
        console.log(
          "AIC ccp window: Microphone permission denied! Ask for permission"
        );
      }
    });
};

export const sendErrorNotification = (title: string, message: string) => {
  return {
    title: title,
    message: message,
    variant: "negative",
  };
};

export function beforeUnloadListener(event: BeforeUnloadEvent) {
  event.preventDefault();
  event.returnValue = "Are you sure you want to exit?";
}

/**
 * Returns the appropriate icon based on the call status.
 * 
 * @param {Call} callerList - The call object containing call details.
 * @returns {JSX.Element|string} - The icon representing the call status or an empty string if no icon matches.
 */

export const getCallIcon = (callerList: Call) => {
  const { self } = callerList;
  if (self?.direction === "INBOUND" && !self?.missed) {
    if (self.isMonitoringCall) return EyeIcon;
    else return IncomingCallIcon;
  }
  if (self?.direction === "OUTBOUND" && self?.missed) {
    return OutgoingMissedIcon;
  } else if (self?.direction === "OUTBOUND") {
    return OutgoingCallIcon;
  } else if (self?.missed) {
    return MissedCallIcon;
  }
  return undefined;
};

export const getCallbackIcon = (): string => {
  //missed icon handled in CVHistorySidebar
  return IncomingCallIcon;
};

export const formatTime = (connectedTime: number | undefined | null, endTime: number) => {
  // If connectedTime is not provided or invalid, fallback to now
  const connectedDate = new Date(
    typeof connectedTime === "number" && !isNaN(connectedTime)
      ? connectedTime
      : Date.now()
  );
  const endDate = new Date(endTime);

  // Handle invalid endDate
  if (isNaN(endDate.getTime())) {
    return {
      formattedConnectedTime: "Invalid Time",
      formattedDifference: "Invalid Time",
    };
  }

  // Helper function to format the date
  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  // Check if the connectedTime is today
  const today = new Date();
  const isToday = connectedDate.toDateString() === today.toDateString();

  // Format connectedTime
  let formattedConnectedTime;
  if (isToday) {
    const options: Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    formattedConnectedTime = `Today ${connectedDate.toLocaleString(
      "en-US",
      options
    )}`;
  } else {
    formattedConnectedTime = formatDate(connectedDate);
  }

  // Calculate difference
  const differenceInSeconds = Math.floor(
    (endDate.getTime() - connectedDate.getTime()) / 1000
  );
  const hours = Math.floor(differenceInSeconds / 3600);
  const minutes = Math.floor((differenceInSeconds % 3600) / 60);
  const seconds = differenceInSeconds % 60;

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}min`);
  if (seconds > 0) parts.push(`${seconds}s`);
  const formattedDifference = parts.join(" ") || "0s";

  return { formattedConnectedTime, formattedDifference };
};

//2025-01-13T11:01:42.577599584Z to the desired format Jan 13 , 25, 4:28 PM
export function formatTimestamp(timestamp: string | number | Date): string {
  let date: Date;

  if (typeof timestamp === "string") {
    // ✅ Remove extra precision beyond milliseconds in ISO strings
    const cleaned = timestamp.replace(/\.(\d{3})\d*Z$/, '.$1Z');
    date = new Date(cleaned);
  } else if (typeof timestamp === "number") {
    // ✅ Convert Unix timestamp (ms) to Date
    date = new Date(timestamp);
  } else {
    date = new Date(timestamp); // Assume valid Date object
  }

  // ❌ Guard against invalid Date
  if (isNaN(date.getTime())) return "";

  const now = new Date();

  const isSameDay = (d1: Date, d2: Date) =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const time = `${formattedHours}:${formattedMinutes} ${ampm}`;

  const month = date.toLocaleString("en-US", { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);

  if (isSameDay(date, now)) {
    return `Today, ${time}`;
  } else if (isSameDay(date, yesterday)) {
    return `Yesterday, ${time}`;
  } else {
    return `${month} ${day}, ${year}, ${time}`;
  }
}



export function fixJson(input: any) {
  // Add quotes around keys (user, TS)
  let fixed = input?.replace(/([{,])\s*([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
  // Add quotes around values that look like strings (user and timestamps)
  fixed = fixed?.replace(/:\s*([a-zA-Z0-9\-T:.Z]+)(?=\s*[},])/g, ': "$1"');
  return JSON.parse(fixed);
}

/**
 * Generates initials and a semi-random background color based on the provided name.
 * 
 * @param {string} name - The name from which to generate initials and color.
 * @param {string} [type="all"] - The type of return value. If "all", returns an object with initials and background color. Otherwise, returns only the background color.
 * @returns {object|string} - An object containing initials and background color if type is "all", otherwise just the background color.
 */

export const getInitialsAndColor = (name: string, type: string = "all") => {
  const names = name.split(" ");
  let initials =
    names.length > 1
      ? names[0].charAt(0) + names[names.length - 1].charAt(0)
      : names[0].charAt(0);
  initials = initials.toUpperCase();

  // Generate a semi-random color using current time
  const randomFactor = Math.floor(Math.random() * 360);
  const colorHash = name
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const backgroundColor = `hsl(${(colorHash + randomFactor) % 360}, 70%, 50%)`;

  if (type === "all") return { initials, backgroundColor };
  else return backgroundColor;
};

// Helper function to format the date Eg: 2024-12-16T06:48:25.611Z to HH:MM PM
export function formatTimeToMMSS(inputTime: string) {
  const inputDate = new Date(inputTime);
  const now = new Date();

  // Check if the date is today
  const isToday =
    inputDate.getDate() === now.getDate() &&
    inputDate.getMonth() === now.getMonth() &&
    inputDate.getFullYear() === now.getFullYear();

  if (isToday) {
    // Format as hh:mm AM/PM
    let hours = inputDate.getHours();
    let minutes = inputDate.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();
    return `${hours}:${formattedMinutes} ${ampm}`;
  } else {
    // Set time to midnight to get accurate day difference
    const dateOnlyNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const dateOnlyInput = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    const diffTime = dateOnlyNow.getTime() - dateOnlyInput.getTime();
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    // Minimum should be 1 day ago
    const daysAgo = diffDays < 1 ? 1 : diffDays;
    return `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
  }
}

export const formattedTime = (time:any) => {
  const hours = Math.floor(time / 3600000)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((time % 3600000) / 60000)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((time % 60000) / 1000)
    .toString()
    .padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};
